<!--顾客到店 区总页面-->
<template>
    <div class="storageassets-module">
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
            <div class="store-box flex-start flex-y-center" v-show="showStoreSelect">
                <div @click="showSelctStoreEvt()" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ selectedStore.storeName }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
            </div>
            <div v-show="selectedStore.departmentType == 3">
                <div class="title-box flex-between flex-y-center">
                    <div class="flex-start flex-y-center">
                        <img class="icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/storageAssets/region-icon.png" alt="">
                        <div class="Blacks font34 bold">区域分布</div>
                    </div>
                    <div class="total-amount flex-end">
                        <div class="txt">数据更新至:{{ regionData.time || '' }}</div>
                    </div>
                </div>
                <div class="unit">单位:人</div>
                <div>
                    <div ref="regionchart" id="regionchart"></div>
                </div>
                <div class="add-up-box flex">
                    <div class="tit"><span>当月来店:</span><span class="num">{{ regionData.inStoreTotal }}</span></div>
                    <div class="tit"><span>6个月内皮测人数:</span><span class="num">{{ regionData.skinTotal }}</span></div>
                    <div class="tit"><span>检测率:</span><span class="num">{{ regionData.skinRatio }}</span></div>
                </div>
            </div>
            <div class="cut-line" v-if="selectedStore.departmentType == 3"></div>
            <div>
                <div class="title-box flex-between flex-y-center">
                    <div class="flex-start flex-y-center">
                        <img class="icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/storageAssets/store-icon.png" alt="">
                        <div class="Blacks font34 bold">门店分布</div>
                    </div>
                    <div class="total-amount flex-end">
                        <div class="txt">数据更新至:{{ storeData.time }}</div>
                    </div>
                </div>
                <div class="unit">单位:人</div>
                <div>
                    <div ref="storechart" id="storechart"></div>
                </div>
                <div class="add-up-box flex">
                    <div class="tit"><span>当月来店:</span><span class="num">{{ storeData.inStoreTotal }}</span></div>
                    <div class="tit"><span>6个月内皮测人数:</span><span class="num">{{ storeData.skinTotal }}</span></div>
                    <div class="tit"><span>检测率:</span><span class="num">{{ storeData.skinRatio }}</span></div>
                </div>
            </div>
            <div class="cut-line"></div>
            <div class="empty-box">
                <div class="flex-col flex-y-center">
                    <img class="empty-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/storageAssets/empty.png" alt="">
                    <div class="empty-txt">客户详细数据请切换至单门店查看</div>
                </div>
            </div>
        </van-pull-refresh>
        <van-popup v-model="showSelctStore" round position="bottom">
            <van-picker show-toolbar ref="storeRef" value-key="storeName" :columns="storeDataList" @cancel="showSelctStore = false" @confirm="confirmSelectStoreEvt" />
        </van-popup>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from "vant";
    import { getCookie } from '@/utils'
    import { findIndexArray } from "@/utils/handleStore"
    import { mapState } from 'vuex'
    import Picker from '@/components/Picker';
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

    export default {
        inject: ['reload'],
        name: "piceRegion",
        components: {
            Picker
        },
        data() {
            return {
                refreshing: false,
                postId: 0, // 岗位
                showRegionPopup: false,
                showRegionStorePopup: false,
                showRegionSelectPopup: false,
                showStoreSelectPopup: false,

                year: "",
                month: "",
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: -1, name: '' },//所选区域
                checkedStore: {  //所选门店
                    name: '',
                    id: -1,
                },
                regionData: {},  // 区域数据
                regionType: {   //  区域筛选
                    id: 1,
                    name: '会员总数'
                },
                storeData: {},  // 门店数据
                storeType: {    //  门店筛选
                    id: 1,
                    name: '会员总数'
                },
                regionChart: null,
                storechart: null,
                changeId: '',
                selectedStore: {},
                storeDataList: [],
                showSelctStore: false,
                cascaderValue: '',
                regionClick: false
            };
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
            showStoreSelect() {
                if (this.storeDataList.length == 1) {
                    if (!this.storeDataList[0].children) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return true
                }
            }
        },
        async mounted() {
            await this.getRegion()
            if (!this.showStoreSelect) {
                return this.$router.replace({ name: 'piceDirector' })
            }
            await this.onLoad()
        },
        methods: {
            getRegion() {
                const sendData = {
                    id: this.selectedStore.id || ''
                }
                return request({
                    url: 'employeeStore/empStoreList',
                    method: 'get',
                    params: sendData
                }).then(res => {
                    if (res.code === 0) {
                        this.storeDataList = res.data
                        if (this.$route.query.storeName) {
                            // 如果是大区经理，第一层去找到id相同的数据赋值，为了取department来展示区域图表
                            const regionStore = res.data.find(i => { return this.$route.query.id == i.id })
                            if (regionStore) {
                                this.selectedStore = regionStore
                            } else {
                                this.selectedStore = this.$route.query
                            }
                        } else {
                            this.selectedStore = res.data[0]
                        }

                    }
                }).catch(error => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            //资产饼图加载
            onLoad() {
                this.initdateData()
            },
            //柱状图-区域
            async initRegionChart() {
                this.getRegionData().then(() => {
                    // 基于准备好的dom，初始化echarts实例
                    if (this.regionchart) {
                        this.regionchart.dispose(); // 销毁之前的实例
                    }
                    this.regionchart = this.$echarts.init(this.$refs.regionchart);
                    let options = {
                        grid: {
                            top: "4%",
                            left: "15",
                            bottom: "13%",
                            right: "7%",
                            containLabel: true,
                        },
                        legend: [
                            {
                                itemWidth: 25,
                                itemHeight: 15,
                                textStyle: { color: '#085AFF', fontSize: '14' },
                                data: [{ name: '来店人数', }],   //rect为矩形
                                bottom: '0',
                                right: '55%'
                            },
                            {
                                itemWidth: 25,
                                itemHeight: 15,
                                textStyle: { color: '#2FD0D5', fontSize: '14' },
                                data: [{ name: '皮测人数', }],   //rect为矩形
                                bottom: '0',
                                right: '15%',
                            },

                        ],
                        xAxis: {
                            splitLine: { //显示分割线
                                show: false
                            },
                            axisLine: {  //显示轴线
                                show: false
                            },
                        },
                        yAxis:
                        {
                            data: this.regionData.regionY,
                            axisTick: {
                                show: true, //显示轴线
                            },
                            splitLine: {
                                show: false,//显示分割线
                            },
                            axisLabel: {
                                textStyle: {
                                    color: "#35434C",
                                    fontSize: 12
                                }
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: "#6E7079",
                                },
                            },

                        },
                        series: [
                            {
                                name: "来店人数",
                                type: "bar",
                                barWidth: "12",
                                itemStyle: {
                                    color: '#085AFF',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: "right",
                                        textStyle: {
                                            color: "#5087EC",
                                            fontSize: 12
                                        },
                                    },
                                },
                                data: this.regionData.inStoreX,
                            },
                            {
                                name: "皮测人数",
                                type: "bar",
                                barWidth: "12",
                                itemStyle: {
                                    color: '#2FD0D5',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: "right",
                                        textStyle: {
                                            color: "#68BBC4",
                                            fontSize: 12
                                        },
                                    },
                                },
                                data: this.regionData.skinX,
                            },
                        ],
                    };
                    this.regionchart.setOption(options, true);
                    // 点击获取该区域id下所有门店的数据
                    this.regionchart.off('click').on('click', (params) => { // 柱形图点击事件
                        this.regionClick = true
                        const matchedItem = this.findMatchingItem(this.storeDataList, params.data.id);
                        if (matchedItem) {
                            this.$nextTick(() => {
                                this.selectedStore = matchedItem
                                this.initStoreChart()
                            })
                        }
                    })

                });

            },
            //柱状图-门店
            async initStoreChart() {
                const _this = this
                await this.getStoreData().then(async () => {
                    // 基于准备好的dom，初始化echarts实例
                    if (this.storechart) {
                        this.storechart.dispose(); // 销毁之前的实例
                    }
                    this.storechart = await this.$echarts.init(this.$refs.storechart);
                    let options = {
                        grid: {
                            top: "30",
                            left: "15",
                            bottom: "40",
                            right: "7%",
                            containLabel: true,
                        },
                        legend: [
                            {
                                itemWidth: 25,
                                itemHeight: 15,
                                textStyle: { color: '#085AFF', fontSize: '14' },
                                data: [{ name: '来店人数', }],   //rect为矩形
                                bottom: '0',
                                right: '50%'
                            },
                            {
                                itemWidth: 25,
                                itemHeight: 15,
                                textStyle: { color: '#2FD0D5', fontSize: '14' },
                                data: [{ name: '皮测人数', }],   //rect为矩形
                                bottom: '0',
                                right: '15%',
                            },

                        ],
                        xAxis: {
                            splitLine: { //显示分割线
                                show: false
                            },
                            axisLine: {  //显示轴线
                                show: false
                            },
                        },
                        yAxis: [
                            {
                                data: this.storeData.regionY,
                                axisTick: {
                                    show: true,
                                },
                                axisLabel: {
                                    show: true,
                                    textStyle: {
                                        color: "#35434C",
                                        fontSize: 12
                                    }
                                },
                                splitLine: {
                                    show: false,
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#6E7079",
                                    },
                                },

                            },
                        ],
                        series: [
                            {
                                name: "来店人数",
                                type: "bar",
                                barWidth: "12",
                                itemStyle: {
                                    barBorderRadius: 0,
                                    color: '#085AFF',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: "right",
                                        textStyle: {
                                            color: "#5087EC",
                                            fontSize: 12
                                        },
                                    },
                                },
                                data: this.storeData.inStoreX,
                            },
                            {
                                name: "皮测人数",
                                type: "bar",
                                barWidth: "12",
                                itemStyle: {
                                    barBorderRadius: 0,
                                    color: '#2FD0D5',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: "right",
                                        textStyle: {
                                            color: "#68BBC4",
                                            fontSize: 12
                                        },
                                    },
                                },
                                data: this.storeData.skinX,
                            },
                        ],
                    };
                    this.storechart.setOption(options);
                    this.$refs.storechart.style.height = this.storeData.regionY.length * 40 + 150 + 'px'
                    this.storechart.resize()
                    // 跳转
                    this.storechart.off('click').on('click', params => { // 柱形图点击事件
                        if (!this.regionClick) {
                            this.$router.replace({
                                name: 'piceDirector',
                                query: { id: params.data.id, storeName: params.name }
                            })
                        }
                        this.$nextTick(() => {
                            this.regionClick = false
                        })
                    })

                });

            },
            // 初始化时间
            initdateData() {
                this.initRegionChart()
                this.initStoreChart()
            },
            // 区域分布数据
            getRegionData() {
                return request({
                    url: `/bfpc/region?id=${this.selectedStore.id}`,
                    method: "get",
                })
                    .then((res) => {
                        this.regionData = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 门店分布数据
            getStoreData() {
                return request({
                    url: `/bfpc/store?id=${this.selectedStore.id}`,
                    method: "get",
                })
                    .then((res) => {
                        this.storeData = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            onRefresh() {
                this.refreshing = false;
                this.onLoad();
            },
            // 三级联动确认
            async confirmSelectStoreEvt(v, s, i) {
                const values = this.$refs.storeRef.getValues();
                if (values.length > 0) {
                    // 从数组中筛选出所有text不为空且id不为0,(全部门店)的项
                    const validItems = values.filter(item => item.storeName != '' && item.id != 0);
                    // 取最后一个有效项
                    const lastValidItem = validItems[validItems.length - 1];
                    if (lastValidItem) {
                        this.selectedStore = lastValidItem;
                        if (lastValidItem.departmentType == 1) {
                            this.$router.push({ name: 'piceDirector', query: { id: lastValidItem.id, storeName: lastValidItem.storeName } })
                            return
                        }
                    }
                    await this.onLoad()
                }
                this.showSelctStore = false;
            },
            // 递归查找匹配的对象
            findMatchingItem(list, targetId) {
                for (let item of list) {
                    // 检查当前项的 id 是否匹配
                    if (item.id === targetId) {
                        return item;
                    }
                    // 如果有 children，递归查找
                    if (item.children && item.children.length) {
                        const found = this.findMatchingItem(item.children, targetId);
                        if (found) return found;
                    }
                }
                return null;
            },
            showSelctStoreEvt() {
                this.showSelctStore = true;
                this.$nextTick(() => {
                    const indexArray = findIndexArray(this.storeDataList, this.selectedStore.id);
                    // 设置选中值
                    this.$refs.storeRef.setIndexes(indexArray);
                })
            }
        },
    };
</script>

<style scoped lang="less">
    .van-pull-refresh {
        min-height: 100%;
    }

    .storageassets-module {
        height: 100%;
        overflow-y: auto;
    }

    .store-box {
        padding: 30px 30px;
        padding-bottom: 0;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }

    .title-box {
        margin-top: 40px;
        padding: 0 30px;

        .icon {
            width: 40px;
            height: 40px;
            margin-right: 20px;
        }

        .total-amount {
            .txt {
                font-size: 26px;
                color: #a0acb5;
            }

            .select-arrow {
                transform: rotate(90deg);
                font-size: 24px;
                margin-left: 20px;
            }
        }
    }

    .price-box {
        padding: 27px 30px 0 30px;

        .unit {
            margin-left: 8px;
            margin-right: 30px;
        }
    }

    .unit {
        margin-right: 34px;
        margin-top: 20px;
        font-size: 26px;
        color: #66757f;
        text-align: right;
    }

    #regionchart {
        width: 100%;
        height: 449px;
    }

    #storechart {
        width: 100%;
        height: 449px;
    }

    .cut-line {
        width: 100%;
        height: 20px;
        background: #f8f8fa;
    }

    .empty-box {
        height: 416px;
        background-color: #fff;
        padding-top: 50px;

        .empty-icon {
            width: 210px;
            height: 210px;
        }

        .empty-txt {
            font-size: 28px;
            color: #a0acb5;
        }
    }

    .add-up-box {
        padding: 30px;
        justify-content: space-around;

        .tit {
            font-size: 24px;
            color: #a0acb5;
            display: flex;
            align-items: center;

            .num {
                padding-top: 2px;
                font-weight: 700;
                color: #35434c;
            }
        }

    }

    .date-box {
        padding: 50px 30px 0 30px;

        .date {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-size: 30px;
            color: #35434c;
        }

        .arrow-l {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-right: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-right: 30px;
        }

        .arrow-r {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-left: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-left: 30px;
        }

        .rate-box {
            color: #66757f;
        }
    }
</style>
